import useConfiguration from '@/composables/configuration/configuration'
import { Dictionary } from '@/composables/advert/advertManager'
import useLocalStorageManager, {
  LS_NAMES,
} from '@/composables/localStorage/localStorageManager'

const { configuration } = useConfiguration()

export class TopicReadPointer {
  newestFrom = '9999999999'
  newestTo = '0000000000'
  oldestFrom = '9999999999'
  oldestTo = '0000000000'
  lastReadDate = 0
  fromCache: boolean

  constructor(topReader?: TopicReadPointer, fromCache = false) {
    if (typeof topReader?.newestFrom !== 'undefined') {
      this.newestFrom = topReader.newestFrom
    }
    if (typeof topReader?.newestTo !== 'undefined') {
      this.newestTo = topReader.newestTo
    }
    if (typeof topReader?.oldestFrom !== 'undefined') {
      this.oldestFrom = topReader.oldestFrom
    }
    if (typeof topReader?.oldestTo !== 'undefined') {
      this.oldestTo = topReader.oldestTo
    }
    if (typeof topReader?.lastReadDate !== 'undefined') {
      this.lastReadDate = topReader.lastReadDate
    }

    this.fromCache = fromCache
  }
}

export default function useReadStorageManager() {
  const getPointerDict = (): Dictionary<TopicReadPointer> => {
    const { getItem } = useLocalStorageManager()

    const data = getItem(LS_NAMES.READ_HISTORY)
    if (data) {
      try {
        return JSON.parse(data)
      } catch (e) {
        return {}
      }
    }

    return {}
  }

  const getPointer = (): TopicReadPointer => {
    const dictionary = getPointerDict()

    if (configuration.widget.topicId in dictionary) {
      return new TopicReadPointer(
        dictionary[configuration.widget.topicId],
        true
      )
    }

    return new TopicReadPointer()
  }

  const updatePointer = (pointer: TopicReadPointer) => {
    const { setItem } = useLocalStorageManager()

    const dictionary = getPointerDict()
    dictionary[configuration.widget.topicId] = pointer
    setItem(LS_NAMES.READ_HISTORY, JSON.stringify(dictionary))
  }

  return {
    getPointer,
    updatePointer,
  }
}
